import React from "react";
import MenuItem from "@mui/material/MenuItem";

const BuildingBlocksMenuListItem = (props) => <MenuItem {...props} />;

export default BuildingBlocksMenuListItem;
